import en from './en';
import es from './es';

const languageFiles = { en, es };

export default languageFiles;
